import { requestTimeout, handleResponse } from '../helpers'

const apiUrl = process.env.REACT_APP_API_URL
const accessToken = process.env.REACT_APP_ACCESS_TOKEN
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME

export const paymentMethodsApi = {
    _get,
}

async function _get() {
    const token = localStorage.getItem(accessToken)
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token },
    }
    return requestTimeout(apiMaxTime, fetch(apiUrl + 'paymentMethods', requestOptions)).then(handleResponse)
}
